export const RollUp = [
    {
        id: 1,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-research-2.jpg?strip=info&w=2000"
    },
    {
        id: 2,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/fisheries-2.jpg?strip=info&w=2000"
    },
    {
        id: 3,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/livelihood-2.jpg?strip=info&w=2000"
    },
    {
        id: 4,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/project-impact-2.jpg?strip=info&w=2000"
    },
    {
        id: 5,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/tourism-potential-2.jpg?strip=info&w=2000"
    },
    {
        id: 6,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/water-current-2.jpg?strip=info&w=2000"
    },
    {
        id: 7,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/water-quality-3.jpg?strip=info&w=2000"
    },
    {
        id: 8,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/rollupbanner2-2.jpg?strip=info&w=2000"
    },
    {
        id: 9,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/crerollupbanner-3.jpg?strip=info&w=2000"
    },
    {
        id: 10,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/banner.jpg?strip=info&w=2000"
    },
]

export const posters = [
    {
        id: 1,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/poster-4.jpg?strip=info&w=2000"
    },
    {
        id: 2,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/poster-5.jpg?strip=info&w=2000"
    },
    {
        id: 3,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/3rd-cet-research-colloquium-1.jpg?strip=info&w=2000"
    },
    {
        id: 4,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/achieving-university-excellence-1.png?strip=info&w=2000"
    },
    {
        id: 5,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/4th-cet-reserach-utilization-colloquium-1.jpg?strip=info&w=2000"
    },
    {
        id: 6,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lecture-1-1.jpg?strip=info&w=2000"
    },
    {
        id: 7,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lecture-2-1.jpg?strip=info&w=2000"
    },
    {
        id: 8,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/patents-poster-1.jpg?strip=info&w=2000"
    },
    {
        id: 9,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lecture-3-1.jpg?strip=info&w=2000"
    },
    {
        id: 10,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lecture-4-1.jpg?strip=info&w=2000"
    },
    {
        id: 11,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lecture-5-1.jpg?strip=info&w=2000"
    },
    {
        id: 12,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/poster-6.jpg?strip=info&w=1700"
    },
    {
        id: 13,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/poster-7.jpg?strip=info&w=2000"
    },
    {
        id: 14,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/259292488_288970193001579_7024973708692828261_n-1.jpg?strip=info&w=1583"
    },
    {
        id: 15,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/magic-realism-poster-1.jpg?strip=info&w=2000"
    },
    {
        id: 16,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/introduction-to-ph-stat-poster-1.png?strip=info&w=2000"
    },
    {
        id: 17,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/poster-8.jpg?strip=info&w=2000"
    },
    {
        id: 18,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/how-to-publish-1.png?strip=info&w=2000"
    },
    {
        id: 19,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/publishing-journey.png?strip=info&w=2000"
    },
    {
        id: 20,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-awareness-flyers-back-1.jpg?strip=info&w=2000"
    },
    {
        id: 21,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-awareness-flyers-front-1.jpg?strip=info&w=2000"
    },
    {
        id: 22,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/barcelona-doc-roms.jpg?strip=info&w=2000"
    },
    {
        id: 23,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/barcelona-sir-mark.jpg?strip=info&w=2000"
    },
]

export const brochures = [
    {
        id: 1,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-brochure-front.jpg?w=1024"
    },
    {
        id: 2,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-brochure-back.jpg?w=1024"
    }
]

export const bookjournalcover = [
    {
        id: 1,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/nursing.jpg?strip=info&w=1468"
    },
    {
        id: 2,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/accomplishment-report.jpg?strip=info&w=2000"
    },
    {
        id: 3,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-monitoring.jpg?strip=info&w=2000"
    },
    {
        id: 4,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/fisheries-monitoring.jpg?strip=info&w=2000"
    },
    {
        id: 5,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/livelihood-3.jpg?strip=info&w=2000"
    },
    {
        id: 6,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/project-impact-assessment.jpg?strip=info&w=2000"
    },
    {
        id: 7,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/tourism-plan.jpg?strip=info&w=2000"
    },
    {
        id: 8,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/tourism.jpg?strip=info&w=2000"
    },
    {
        id: 9,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/water-current-3.jpg?strip=info&w=2000"
    },
    {
        id: 10,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/water-quality-4.jpg?strip=info&w=2000"
    },
    {
        id: 11,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/final-book-of-research-abstracts.jpg?strip=info&w=2000"
    },
    {
        id: 12,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/ba-1.jpg?strip=info&w=2000"
    },
    {
        id: 13,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/rhi-new-cover-final.jpg?strip=info&w=2000"
    },
]

export const certificate = [
    {
        id: 1,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/cert-1.jpg?w=1024"
    }
]

export const others = [
    {
        id: 1,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/bag.jpg?strip=info&w=2000"
    },
    {
        id: 2,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/cap.png?strip=info&w=2000"
    },
    {
        id: 3,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/1.jpg?strip=info&w=2000"
    },
    {
        id: 4,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/dolphin-sticker.png?strip=info&w=750"
    },
    {
        id: 5,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lumba-lumba-sticker.png?strip=info&w=900"
    },
    {
        id: 6,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/lumba-lumba-white.png?strip=info&w=2000"
    },
    {
        id: 7,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/postcard-front-1a.jpg?strip=info&w=1794"
    },
    {
        id: 8,
        img: "https://karlvonresume1.files.wordpress.com/2023/02/calendar-cover.jpg?strip=info&w=2000"
    },
]

export const chatapp = [
    {
        id: 1,
        icon: "assets/chat.png",
        img: "assets/ChatApp.JPG",
        title: "Chat App",
        description: "A personal project Chat App like Messenger created using ReactJS "
    },
    {
        id: 2,
        icon: "assets/pic with suit.png",
        img: "assets/Portfolio.JPG",
        title: "Portfolio",
        description: "A personal project portfolio created using ReactJS"

    }
]

export const certs = [
    {
        id: 1,
        img: "assets/Cert1.JPG",
    },
]
